import template from './component.tpl.html';
import AlMediaManagerController from './controller';

import './sub-components/directory-tree/component';
import './sub-components/directory-content-listing/component';
import './sub-components/drop-zone/component';

angular
    .module('festzelt-os.modules.media')
    .component('alMediaManager', {
        bindings: {
            enableFileSelection: '<',
            onFileSelection: '&',
            currentDirectory: '<',
            preSelectedFileUuid: '<'
        },
        controller: AlMediaManagerController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-manager/component.js